
define('template!webshopAttributesMatchingView', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="list-pane">\n    <div class="list-header">\n        <input type="text" class="search am-input" placeholder="' +
((__t = ( _.i18n('attributeMatching.searchKey', null, 'Search an attribute (name, code)') )) == null ? '' : __t) +
'"/>\n        <div class="add-region"></div>\n    </div>\n    <label class="list-option">\n        <input type="checkbox" class="only-filters"/> ' +
((__t = ( _.i18n('attributeMatching.onlyFilters', null, 'Only the webshop filters') )) == null ? '' : __t) +
'\n    </label>\n    <div class="keys"></div>\n</div>\n<div class="detail-region">\n    <div class="detail-placeholder">' +
((__t = ( _.i18n('attributeMatching.selectKey', null, 'Select an attribute to see its values and its supplier matching') )) == null ? '' : __t) +
'</div>\n</div>\n';

}
return __p
};});

